import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Element } from '../../../common/html/element'
import { Notification } from '../../../common/notification'
import {
  selectComponentAuthorized,
  selectUserType,
} from '../../../layout/store/slice'
import { AUTHORIZATION_TYPE } from '../../../utils/authorization'
import { TitleComponent } from './TitleComponent'

export const AuthorizationLayout = ({ title, id, children }) => {
  const AUTHORIZATION = useSelector(selectComponentAuthorized)
  const userType = useSelector(selectUserType)

  const allowFeature =
    AUTHORIZATION.dashboard[id][userType.userTypeId] ===
    AUTHORIZATION_TYPE.ALLOW

  if (!allowFeature) {
    return (
      <Element
        className="positionRelative h100"
        style={{
          backgroundColor: '#FFFFFF',
          borderRadius: 8,
          padding: '12px 8px',
        }}
      >
        <div className="flexColumn h100">
          <TitleComponent title={title} style={{ whiteSpace: 'nowrap' }} />
          <div className="flex1">
            <Notification
              value="dashboard.yourPortfolio.canUpgrade"
              style={{ textAlign: 'center' }}
            />
          </div>
        </div>
      </Element>
    )
  }

  return children
}

AuthorizationLayout.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
}
